import { FC, ReactNode } from 'react';
import { isAuthorizedAtom } from '@/lib/store/Contentstore';
import { Logo } from './Logo';
import { useAtomValue } from 'jotai';
import HeaderExternalSiteLinks from './HeaderExternalSiteLinks';
import Logout from './Logout';
import MobileMenuButton from './MobileMenuButton';
import styles from './Header.module.css';

const Header: FC = (): ReactNode => {
  const isAuthorized = useAtomValue(isAuthorizedAtom);

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <a href="/">
          <div className={styles.logo}>
            <Logo />
          </div>
        </a>
        {isAuthorized && <HeaderExternalSiteLinks mobile={false}></HeaderExternalSiteLinks>}
        <div className={styles.right}>
          <Logout />
          {isAuthorized && <MobileMenuButton />}
        </div>
      </div>
    </header>
  );
};

export default Header;
